import { render } from "./RecentlyModifiedInstances.vue?vue&type=template&id=1fdaceeb"
import script from "./RecentlyModifiedInstances.vue?vue&type=script&lang=js"
export * from "./RecentlyModifiedInstances.vue?vue&type=script&lang=js"

import "./RecentlyModifiedInstances.vue?vue&type=style&index=0&id=1fdaceeb&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__